/*
 * Copyright (c) 2019. World Wide Generation Ltd
 */

import { BaseApi } from './BaseApi';
import { Observable } from 'rxjs';

export class UserApi extends BaseApi {
  endPoint: string = '/api/admin/users';

  public setPassword(password: any): Observable<any> {
    console.log('UserApi.setPassword not implemented');
    return;
  }

  public updateAttributes(id: any, attributes: any): Observable<any> {
    // TODO
    console.log('UserApi.updateAttributes not implemented');
    return;
  }

  public getUnreadMessages(id: any): Observable<any> {
    const _routeParams = {
      id: id
    };
    return this._get(this.endPoint + '/unread-messages', _routeParams);
  }

  public getUnreadMessagesCount(id: any): Observable<any> {
    const _routeParams = {
      id: id
    };
    return this._get(this.endPoint + '/unread-messages-count', _routeParams);
  }

  public findByEmail(email: any): Observable<any> {
    const dynamicEndPoint = this.endPoint + '/email/:email';
    const _routeParams = {
      email: email
    };
    return this._get(dynamicEndPoint, _routeParams);
  }

  public activate(id: string, isManager: boolean) {
    const query = isManager ? `?manager=${Boolean(isManager)}` : '';
    return this._put(
      `${this.endPoint}/:id/activate${query}`,
      { id },
      {}
    );
  }

  public resendActivationEmail(id: string) {
    return this._post(`${this.endPoint}/:id/email`, { id }, {})
  }

  public lock(id: string) {
    return this._put(`${this.endPoint}/:id/lock`, { id }, {});
  }

  public unlock(id: string) {
    return this._put(`${this.endPoint}/:id/unlock`, { id }, {});
  }
}
